import { combineReducers } from "redux";
import chapters from "../modules/admin-modules/chapters/Reducer";
import events from "../modules/admin-modules/events/Reducer";
import exams from "../modules/admin-modules/exams/Reducer";
import grades from "../modules/admin-modules/grades/Reducer";
import groups from "../modules/admin-modules/groups/Reducer";
import homeworks from "../modules/admin-modules/homework/Reducer";
import lectures from "../modules/admin-modules/lectures/Reducer";
import lessons from "../modules/admin-modules/lessons/Reducer";
import adminLiveVideos from "../modules/admin-modules/liveVideos/Reducer";
import modelsReducer from "../modules/admin-modules/models/Reducer";
import payments from "../modules/admin-modules/payment/Reducer";
import playlists from "../modules/admin-modules/playlists/Reducer";
import questionsBank from "../modules/admin-modules/questions-bank/Reducer";
import adminSections from "../modules/admin-modules/sections/Reducer";
import students from "../modules/admin-modules/students/Reducer";
import subjects from "../modules/admin-modules/subjects/Reducer";
import tags from "../modules/admin-modules/tags/Reducer";
import teachers from "../modules/admin-modules/teachers/Reducer";
import teacherassistants from "../modules/admin-modules/teachersAssistant/Reducer";
import videos from "../modules/admin-modules/videos/Reducer";
import authReducer from "../modules/auth/Reducer";
import publicData from "../modules/public/publicData/Reducer";
import studentChapters from "../modules/students-modules/chapters/Reducer";
import studentCourses from "../modules/students-modules/courses/Reducer";
import chapterExams from "../modules/students-modules/exams/Reducer";
import studentGroups from "../modules/students-modules/groups/Reducer";
import chapterHomeworks from "../modules/students-modules/homework/Reducer";
import chapterlessons from "../modules/students-modules/lessons/Reducer";
import studentLiveVideos from "../modules/students-modules/live-videos/Reducer";
import performance from "../modules/students-modules/performance/Reducer";
import questions from "../modules/students-modules/questions/Reducer";
import sections from "../modules/students-modules/sections/Reducer";
import studentExams from "../modules/students-modules/student-exams/Reducer";
import systemSubjects from "../modules/students-modules/subjects/Reducer";
import chaptervideos from "../modules/students-modules/videos/Reducer";
import superadminBuckets from "../modules/superadmin-modules/bucket/Reducer";
import superadminChapters from "../modules/superadmin-modules/chapters/Reducer";
import courses from "../modules/superadmin-modules/courses/Reducer";
import superadminExams from "../modules/superadmin-modules/exams/Reducer";
import superadminGroups from "../modules/superadmin-modules/groups/Reducer";
import superadminHomeworks from "../modules/superadmin-modules/homework/Reducer";
import superadminPdfs from "../modules/superadmin-modules/lectures/Reducer";
import superadminLiveVideos from "../modules/superadmin-modules/live-videos/Reducer";
import superadminPayments from "../modules/superadmin-modules/payment/Reducer";
import superadminQuestionsBank from "../modules/superadmin-modules/questions-bank/Reducer";
import redoRequests from "../modules/superadmin-modules/redo-requests/Reducer";
import reports from "../modules/superadmin-modules/reports/Reducer";
import SuperadminSections from "../modules/superadmin-modules/sections/Reducer";
import superadminstudents from "../modules/superadmin-modules/students/Reducer";
import superadminSubjects from "../modules/superadmin-modules/subjects/Reducer";
import superadminTags from "../modules/superadmin-modules/tags/Reducer";
import superadminTeachers from "../modules/superadmin-modules/teachers/Reducer";
import requests from "../modules/superadmin-modules/video-requests/Reducer";
import superadminvideos from "../modules/superadmin-modules/videos/Reducer";
import user from "../modules/user/Reducer";

// import {actions as authActions} from "../modules/auth/Reducer";

const appReducer = combineReducers({
  auth: authReducer,
  user: user,
  lessons: lessons,
  model: modelsReducer,
  teachers: teachers,
  teacherassistants: teacherassistants,
  videos: videos,
  students: students,
  groups: groups,
  grades: grades,
  subjects: subjects,
  chapters: chapters,
  lectures: lectures,
  exams: exams,
  tags: tags,
  playlists: playlists,
  questionsBank: questionsBank,
  studentChapters: studentChapters,
  chapterVideos: chaptervideos,
  chapterLessons: chapterlessons,
  chapterExams: chapterExams,
  events: events,
  questions: questions,
  // videoRequests: requests,
  studentExams: studentExams,
  reports: reports,
  payments: payments,
  performance: performance,
  redoRequests: redoRequests,
  homework: homeworks,
  studentHomework: chapterHomeworks,
  sections: sections,
  adminLiveVideos: adminLiveVideos,
  adminSections: adminSections,
  systemSubjects: systemSubjects,
  courses: courses,
  superadminSubjects: superadminSubjects,
  superadminTeachers: superadminTeachers,
  superadminChapters: superadminChapters,
  superadminstudents: superadminstudents,
  superadminVideos: superadminvideos,
  superadminLiveVideos: superadminLiveVideos,
  superadminPayment: superadminPayments,
  superadminPdfs: superadminPdfs,
  superadminTags: superadminTags,
  superadminBuckets: superadminBuckets,
  superadminQuestionsBank: superadminQuestionsBank,
  superadminExams: superadminExams,
  superadminSections: SuperadminSections,
  superadminGroups: superadminGroups,
  public: publicData,
  studentCourses: studentCourses,
  studentGroups: studentGroups,
  studentLiveVideos: studentLiveVideos,
  videoRequests: requests,
  superadminHomeworks: superadminHomeworks,
});

const rootReducer = (state, action) => {
  return appReducer(state, action);
};

export default rootReducer;
